import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class WindowService {

  refWindow: any;

  prevX;
  prevY;

  private windows = new BehaviorSubject<any>([]); // начальное значение false
  windows$ = this.windows.asObservable(); // поток для подписки


  constructor() {
  }

  public openWindow(component, config = {}, onClose) {

    const w = {component, name: 'test', onClose};
    this.windows.next([...this.windows.value, w]);
    return w;
  }

  public closeWindow(window) {
    const w = this.windows.value.find(val => val === window);
    if (w?.onClose) {
      w.onClose();
    }
    this.windows.next([...this.windows.value.filter((val => val !== window))]);
  }
}
